import { createStore as createReduxStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { rootReducer } from '../reducers/root';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const buildInitialState = (props) => {
    const { realtimeEnabled, soundEnabled, username } = props;

    return {
        settings: { realtimeEnabled, soundEnabled },
        username,
    };
};

export function createStore(props, extraProps) {
    return createReduxStore(
        rootReducer,
        buildInitialState(props),
        composeEnhancers(applyMiddleware(thunk.withExtraArgument(extraProps)))
    );
}
